import { Component, OnInit,Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { Angular2CsvModule } from 'angular2-csv';
import { MyDatePickerModule, IMyDpOptions } from 'mydatepicker';
declare var getHexAscii: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import 'rxjs/Rx';
import {filter} from "rxjs/operator/filter";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
@Pipe({
  name: 'dateFormatPipe',
})
@Component({
  selector: 'app-customer-activity',
  templateUrl: './customer-activity.component.html',
  styleUrls: ['./customer-activity.component.css'],
  providers: [DatePipe]
})
export class CustomerActivityComponent implements OnInit,PipeTransform  {
  public filterQuery = '';
    public rowsOnPage = 5;
    public sortBy = 'activity';
    public sortOrder = 'asc';
  isDisabled:boolean=false;
  data: any [];
  isShow : string ='show1';
  fromDate : any;
   toDate : any;
    fromDate1 : any;
   toDate1 : any;
   fromDate2 : any ;
  toDate2 : any ;
  fDrmaote2: string;
  activityLogResp : any;
  activityLogList : any;
  excelOrPdfName : string;
  totalClosingAmount : any;
  formatedDate : string='';
  messageForDate : string='';
  messageForDate1 : string ='';
  messageForDate2 : string ='';
  fromDateNull : string='';
  toDateNull : string ='';
  fromGreaterCurrent : string='';
  mytime:Date = new Date();
  error="";
  currentYear:any= this.mytime.getUTCFullYear();
  currentDate:any= this.mytime.getUTCDate()+1;
  currentMonth:any= this.mytime.getUTCMonth() + 1;
  currentMonth1:any= this.mytime.getUTCMonth() + 7;
  fromyear=this.mytime.getUTCFullYear()-1;
isLog:string="";
  transform(value: string) {
    var datePipe = new DatePipe("en-US");
    value = datePipe.transform(value, 'MM-dd-yyyy');
    return value;
  }
  constructor(private webService: CallBackEndService,private datePipe: DatePipe,private spinnerService: Ng4LoadingSpinnerService) { }

  
  ngOnInit() {
    this.formatedDate = this.datePipe.transform(new Date(), 'dd-MM-yy');
  
   
  
  }
//  myDatePickerOptions: IMyDpOptions = {
//    dateFormat: 'dd-mm-yyyy',
//    editableDateField:false,
//    disableUntil:{year: this.fromyear, month: this.currentMonth, day: this.currentDate},
//  };
   myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    editableDateField:false,
    disableUntil:{year: this.fromyear, month: this.currentMonth, day: this.currentDate-2},
     disableSince:{year: this.currentYear, month: this.currentMonth, day: this.currentDate},
  };

  myDatePickerOptions1: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    editableDateField:false,
     disableUntil:{year: this.fromyear, month: this.currentMonth, day: this.currentDate-2},
    disableSince:{year: this.currentYear, month: this.currentMonth, day: this.currentDate},
  };
  dateconvert(monthNumber) { //1 = January
        var monthNames = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
            'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
        return monthNames[monthNumber - 1];
    }
  
  activityLog() {
    this.fromDateNull='';
    this.toDateNull='';
    this.messageForDate='';
    this.messageForDate1 = '';
    this.messageForDate2 = '';
    this.fromGreaterCurrent='';
    if(this.fromDate==='' || this.fromDate===undefined || this.fromDate===null)
    {
      this.fromDateNull='no';
    }
    else if(this.toDate==='' || this.toDate===undefined || this.toDate===null)
    {
      this.toDateNull='no';
    }
    else {
      console.log("to date " + this.fromDate + "to date " + this.toDate+"formated date "+this.formatedDate);
      var date1 = (this.fromDate.date.day + "-" + this.dateconvert(this.fromDate.date.month) + "-" + this.fromDate.date.year).split("-");
      var date2 = (this.toDate.date.day + "-" + this.dateconvert(this.toDate.date.month) + "-" + this.toDate.date.year).split("-");
      console.log("fromDate--"+this.fromDate.date.day + "-" + this.dateconvert(this.fromDate.date.month) + "-" + this.fromDate.date.year);
      console.log("toDate--------"+this.toDate.date.day + "-" + this.dateconvert(this.toDate.date.month) + "-" + this.toDate.date.year);
      console.log("to date " + this.fromDate + "to date " + this.toDate + "formated date " + this.formatedDate);
      var date3 = this.formatedDate.split("-");
       console.log(date3);
      var monthInNo1 = this.getMonthInNo(date1[1]);
      var monthInNo2 = this.getMonthInNo(date2[1]);
      var monthInNo3 = this.getMonthInNo(date3[1]);
      console.log(monthInNo2+"--M2");
      var yearNumber1 = Number(date1[2] || 0);
      var yearNumber2 = Number(date2[2] || 0);
      var yearNumber3 = Number(date3[2] || 0);
      var monthNumber1 = Number(monthInNo1 || 0);
      var monthNumber2 = Number(monthInNo2 || 0);
      var monthNumber3 = Number(monthInNo3 || 0);
console.log("date11--"+ date1[1] + monthInNo1 + date1[0]+"date1--"+date1[0]+date1[1]);
      var date11 = date1[2] + monthInNo1 + date1[0];
      var date21 = date2[2] + monthInNo2 + date2[0];
      var date31 = date3[2] + monthInNo3 + date3[0];
      var d1 = Date.parse(date1[0]+"-"+date1[1]+"-"+date1[2]);
      var d2 = Date.parse(date2[0]+"-"+date2[1]+"-"+date2[2]);
      var d3 = Date.parse(date3[0]+"-"+date3[1]+"-"+date3[2]);
      console.log("date1 "+date21+"date3 "+date31+"date2-"+date11+"Date2[0]---"+date1[1]);
     if (d1 > d2) {
        this.messageForDate = 'no';
      }
      // else if (d1 > d3) {
      //   this.fromGreaterCurrent = 'no';
      // }
      else {
         this.spinnerService.show();
        this.isDisabled = true;

       sessionStorage.setItem('timeLeftGlobal', JSON.stringify(180));
        console.log("global storage issss " +sessionStorage.setItem('timeLeftGlobal', JSON.stringify(180)));
        const request: IbRequest = new IbRequest();
        let response: IbResponse = null;
       

        console.log("frmsdf year " + this.fromDate.date.day + "-" + this.dateconvert(this.fromDate.date.month) + "-" + this.fromDate.date.year);
        console.log("frmsdf year " + this.toDate.date.day + "-" + this.dateconvert(this.toDate.date.month) + "-" + this.toDate.date.year);

        console.log("frm day " + JSON.stringify(this.fromDate));
        console.log("to day " + JSON.stringify(this.toDate));
        this.fromDate1 = this.fromDate.date.day + "-" + this.dateconvert(this.fromDate.date.month) + "-" + this.fromDate.date.year;
        this.toDate1 = this.toDate.date.day + "-" + this.dateconvert(this.toDate.date.month) + "-" + this.toDate.date.year;
        this.fDrmaote2 = this.fromDate1.date;
        this.toDate2 = this.toDate1.date;
        console.log("frm day " + (this.fDrmaote2));
        console.log("to day " + (this.toDate2));
        request.param1 = getHexAscii('', this.fromDate1 + this.toDate1+sessionStorage.getItem('storedUserName'));

        request.param2 = this.fromDate1 + "";
        request.param3 = this.toDate1 + "";
        request.param4 =sessionStorage.getItem('storedUserName');
        console.log("from date  " + this.fromDate1 + "to date  " + this.fromDate1);



        
        this.webService.getResponse(request, 'getActivityLog').subscribe((data: IbResponse) => {
			  this.spinnerService.hide();
          this.activityLogResp = data;
          
          if (this.activityLogResp.status === 'S101') {
            alert('Malicious Request Detected');
          }
          if (this.activityLogResp.status === 'S200') {
            this.data = this.activityLogResp.param6;
            //this.data = this.activityLogList;
            this.isLog='yes';
            console.log('len : '+this.isLog.length);
            this.excelOrPdfName = this.activityLogResp.param1 + '_' + this.activityLogResp.param2;
            this.isDisabled = false;

          } else {
            this.isDisabled = false;
            this.error=this.activityLogResp.statusDescription;
          }
        });
      }
    }
  }
  
  generatePdf=function(){
    var pdf = new jsPDF();
    
    var a = Number(25 || 0);
        var b = Number(5 || 0); 
        var c = Number(35 || 0);
        var d = Number(25 || 0);
        var e = Number(184 || 0);
        var f = Number(40 || 0);
        var g = Number(3 || 0);
        var h = Number(2 || 0); 
        var i = Number(1 || 0);
        
    pdf.setFontSize(6);
    c=d+5;
    pdf.line(2, a-3, e, a-3);
         for(const [key, value] of Object.entries(this.data)) {  
           let srNo : number = +key;
         // for (let value in this.data ) {           
            if(i===1){
            pdf.setFontType("bolditalic");
            pdf.setTextColor(0, 0, 255);
 
        pdf.text(h, a, 'SR. No.');
            pdf.text(h+8, a, 'Date');
            pdf.text(h+28, a, 'Time');
            pdf.text(h+48, a, 'Activity');
           // pdf.text(h+108, a, 'IP Address');
           pdf.text(h+108, a, 'Status'); 
           // pdf.text(h+128, a, 'Status');

            pdf.setTextColor(100);
            }
            i++;
            a=a+b;
        c=c+5;
        pdf.line(2, a-3, e, a-3);       
        
        if((i-1)%f===0){
            pdf.setFontType("bolditalic");
            pdf.setTextColor(0, 0, 255);
              
            pdf.text(h, a, 'SR. No.');
            pdf.text(h+8, a, 'Date');
            pdf.text(h+28, a, 'Time');
            pdf.text(h+48, a, 'Activity');
          //  pdf.text(h+108, a, 'IP Address');
          pdf.text(h+108, a, 'Status'); 
           // pdf.text(h+128, a, 'Status');  
        
            

            pdf.setTextColor(100);
            a=a+b;
            c=c+5;
            i++;
            pdf.line(2, a-3, e, a-3); 

        pdf.text(h, a, (srNo+1).toString());
            pdf.text(h+8, a, value.date+'');
            pdf.text(h+28, a, value.time+'');
            pdf.text(h+48, a, (value.activity));
           // pdf.text(h+108, a, value.macIpAddr+'');
            // if(value.status.length()>50){
            //   pdf.text(h+128, a, value.status.substring(0,50)+'');
            //   pdf.text(h+128, a, value.status.substring(50)+'');
            // }else{
            //   pdf.text(h+128, a, value.status+'');
            // }
           console.log('in pdf---------------');
            if((value.status+'').length>65){
              pdf.text(h+108, a, value.status.substring(0,65)+'--');//+'\n'+value.status.substring(50)+'');   // \n
              //b=b+1;
              // pdf.text(h+128, a, value.status.substring(50)+'');
            }else{
              pdf.text(h+108, a, value.status+'');
             
            }
           
            // pdf.text(h+128, a, value.status+'');          
            
        }else{
          pdf.text(h, a, (srNo+1).toString());
            pdf.text(h+8, a, value.date+'');
            pdf.text(h+28, a, value.time+'');
            pdf.text(h+48, a, (value.activity));
           // pdf.text(h+108, a, value.macIpAddr+'');
            
            if((value.status+'').length>65){
              pdf.text(h+108, a, value.status.substring(0,65)+'--');//+'\n'+value.status.substring(50)+'');   // \n
            
              // pdf.text(h+128, a, value.status.substring(50)+'');
            }else{
              pdf.text(h+108, a, value.status+'');
            }
            
            //pdf.text(h+128, a, value.status+'');    
        }
        this.totalClosingAmount = value.balance;
        if(i%f===0){
          pdf.line(h, d-3, h, c-3);
          pdf.line(h+7, d-3, h+7, c-3);
          pdf.line(h+27, d-3, h+27, c-3);
          pdf.line(h+47, d-3, h+47, c-3);
          pdf.line(h+107, d-3, h+107, c-3);
          //pdf.line(h+127, d-3, h+127, c-3);
          pdf.line(h+182, d-3, h+182, c-3);
          
          pdf.line(h, a+2, e, a+2);
          
          pdf.addPage();
          a=20;
          d=25;
          c=25;
         // b=6
        }
        }
    
        pdf.line(h, d-3, h, c-3);
          pdf.line(h+7, d-3, h+7, c-3);
          pdf.line(h+27, d-3, h+27, c-3);
          pdf.line(h+47, d-3, h+47, c-3);
          pdf.line(h+107, d-3, h+107, c-3);
          //pdf.line(h+127, d-3, h+127, c-3);
          pdf.line(h+182, d-3, h+182, c-3);

        // pdf.line(h, d-3, h, c+1);
        //   pdf.line(h+7, d-3, h+7, c+1);
        //   pdf.line(h+27, d-3, h+27, c+1);
        //   pdf.line(h+47, d-3, h+47, c+1);
        //   pdf.line(h+107, d-3, h+107, c+1);
        //   pdf.line(h+127, d-3, h+127, c+1);
        //   pdf.line(h+182, d-3, h+182, c+1);
    
          /*pdf.line(h, a-3, e, a-3); */
          pdf.line(h, a-3+5, e, a-3+5);
    
    var img = new Image;
    img.onload = function() {
      pdf.setPage(1);
        pdf.addImage(this, 2, 0, 100, 17);
        pdf.save("ActivityLog"+".pdf");
    };
    img.crossOrigin = "";
    img.src = "assets/img/LogoWithName.png";    
  };
  
  downloadcsv(){
	 
	var csvData = this.ConvertToCSV(this.data);
	 console.log(csvData);
    var a = document.createElement("a");
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var blob = new Blob([csvData], { type: 'text/csv' });
    var url= window.URL.createObjectURL(blob);
    a.href = url;
    a.download = 'ActivityLog.csv';
    a.click();
}
   ConvertToCSV(objArray) {
            var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
            var str = '';
            var row = "";
 
            for (var index in objArray[0]) {
                //Now convert each value to string and comma-separated
				row += index + ',';
			
				delete objArray[0].activityDesc;
				
				delete objArray[0].macIpAddr;
				
			}
			
            row = row.slice(0, -1);
            //append Label row with line break
            str += row + '\r\n';
 
            for (var i = 0; i < array.length; i++) {
				var line = '';
				delete array[i].activityDesc;
				
				delete array[i].macIpAddr;
                for (var index in array[i]) {
                    if (line !== '') { line += ','; }
 
                    line += array[i][index];
                }
                str += line + '\r\n';
            }
            return str;
        }


  isFromDateLessThanOrEqualToDate(){
    //var formatedDate = this.transform(new Date());
    var date1=this.fromDate.split("-");
    var date2=this.toDate.split("-");
    var date3=this.formatedDate.split("-");

    var monthInNo1=this.getMonthInNo(date1[1]);
    var monthInNo2=this.getMonthInNo(date2[1]);
    var monthInNo3=this.getMonthInNo(date3[1]);

    var yearNumber1 = Number(date1[2] || 0);
    var yearNumber2 = Number(date2[2] || 0);
    var yearNumber3 = Number(date3[2] || 0);
    var monthNumber1 = Number(monthInNo1 || 0);
    var monthNumber2 = Number(monthInNo2 || 0);
    var monthNumber3 = Number(monthInNo3 || 0);

    var date11=date1[2]+monthInNo1+date1[0];
    var date21=date2[2]+monthInNo2+date2[0];
    var date31=date3[2]+monthInNo3+date3[0];

    if(date11>date21 || date21>date31 || (yearNumber1<yearNumber2 && (monthNumber1-monthNumber2)<0) || yearNumber2-yearNumber1>1) {
      return false;
    }
    else {
      return true;
    }
  }

  getMonthInNo(month){
    var monthInNo='';
    if(month.toLowerCase()==='jan') {
      monthInNo='01';
    }
    if(month.toLowerCase()==='feb') {
      monthInNo='02';
    }
    if(month.toLowerCase()==='mar') {
      monthInNo='03';
    }
    if(month.toLowerCase()==='apr') {
      monthInNo='04';
    }
    if(month.toLowerCase()==='may') {
      monthInNo='05';
    }
    if(month.toLowerCase()==='jun') {
      monthInNo='06';
    }
    if(month.toLowerCase()==='jul') {
      monthInNo='07';
    }
    if(month.toLowerCase()==='aug') {
      monthInNo='08';
    }
    if(month.toLowerCase()==='sep') {
      monthInNo='09';
    }
    if(month.toLowerCase()==='oct') {
      monthInNo='10';
    }
    if(month.toLowerCase()==='nov') {
      monthInNo='11';
    }
    if(month.toLowerCase()==='dec') {
      monthInNo='12';
    }
    return monthInNo;
  }


  isFromDateLessThanOrEqualToDate1(){
    var date1=this.fromDate.split("-");
    var date2=this.toDate.split("-");
    var date3=this.formatedDate.split("-");

    var monthInNo1=this.getMonthInNo(date1[1]);
    var monthInNo2=this.getMonthInNo(date2[1])
    var monthInNo3=this.getMonthInNo(date3[1])

    var yearNumber1 = Number(date1[2] || 0);
    var yearNumber2 = Number(date2[2] || 0);
    var yearNumber3 = Number(date3[2] || 0);
    var monthNumber1 = Number(monthInNo1 || 0);
    var monthNumber2 = Number(monthInNo2 || 0);
    var monthNumber3 = Number(monthInNo3 || 0);

    var date11=date1[2]+monthInNo1+date1[0];
    var date21=date2[2]+monthInNo2+date2[0];
    var date31=date3[2]+monthInNo3+date3[0];
  console.log("to date "+this.fromDate +"to date "+this.toDate);

    if(date11>date21) {
      this.messageForDate='no';
    }
    else {
      this.messageForDate='yes';
    }
    if(date21>date31) {
      this.messageForDate1='no';
    }
    else {
      this.messageForDate1='yes';
    }
    if((yearNumber1<yearNumber2 && (monthNumber1-monthNumber2)<0) || yearNumber2-yearNumber1>1) {
      this.messageForDate2='no';
    }
    else {
      this.messageForDate2='yes';
    }
  }

  removeDateMessage()
  {
    this.messageForDate='';
    this.messageForDate1='';
    this.messageForDate2='';
    this.toDateNull='';
    this.fromDateNull='';
    this.error="";
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/customer-activity/customer-activity.component.ts